import axios from "axios";

export class RegistryService {
  private static rootUrl = '/oci-registry';

  static async getTagsForImage(imageName: string): Promise<string[]> {
    try {
      const response = await axios.get<string[]>(`${this.rootUrl}/${encodeURIComponent(imageName)}`);
      return response.data;
    } catch (error) {
      console.error('Failed to fetch tags:', error);
      return [];
    }
  }
}
